import {
  BoxConnectionItem,
  BoxDetailConnectionModalProps
} from '@/box/interface'
import { Modal } from 'antd'
import React, { useState } from 'react'
import { BoxDetailConnection } from '.'

export const BoxDetailConnectionModal: React.FC<BoxDetailConnectionModalProps> =
  (props: BoxDetailConnectionModalProps) => {
    const { visible, editItem, onVisibleChange, onSave } = props
    const [formResult, setFormResult] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)

    const handleSave = async (item: BoxConnectionItem) => {
      setFormResult(false)
      await onSave?.(item)
      setLoading(false)
    }

    return (
      <Modal
        destroyOnClose={true}
        maskClosable={false}
        title='编辑连接'
        width={600}
        visible={visible}
        onCancel={() => onVisibleChange?.(false)}
        okButtonProps={{ loading: loading }}
        onOk={() => {
          setLoading(true)
          setFormResult(true)
        }}
      >
        <BoxDetailConnection
          colSpan={24}
          editItem={editItem}
          formResult={formResult}
          onSave={handleSave}
          onFormValidate={() => {
            setFormResult(false)
            setLoading(false)
          }}
        />
      </Modal>
    )
  }
